module.exports = __webpack_public_path__ + "img/JamesM.7197ce93.jpg";